import React from 'react';
import classNames from 'classnames';
import { MESSAGE_DIRECTION } from '@whatsper/texterchat-common';
import Image from '../../../../../../components/icons/image';
import { isArray } from 'lodash';
import { getFilePreviewUrl } from '../../../../../../store/FilesStore';
import styles from './ImagePostback.module.scss';
const ImagePostback = ({ context, name, type, incoming, color, invertChatColor }) => {
    let { fileId, url, caption } = context.media[0];
    if (fileId) {
        url = getFilePreviewUrl(fileId);
    }
    return (React.createElement("div", { className: classNames(styles.main, {
            [styles.reply]: type === 'reply',
        }) },
        React.createElement("div", { className: styles.info },
            React.createElement("p", { className: classNames(styles.name, {
                    [styles.incoming]: incoming,
                    [styles.invertColors]: !incoming && invertChatColor && type === 'message',
                }) }, context.direction === MESSAGE_DIRECTION.IN ? name : 'You'),
            React.createElement("div", { className: classNames(styles.text, {
                    [styles.reply]: type === 'reply',
                    [styles.invertColors]: !incoming && type === 'message',
                }) },
                React.createElement(Image, { color: incoming || type === 'reply' ? (isArray(color) ? color[0] : color) : '#ffffff', width: 24, height: 24 }),
                caption || 'Photo')),
        React.createElement("img", { className: styles.picture, src: url })));
};
export default ImagePostback;
